import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound: React.FC = () => {
  return (
    <div className="not-found">
      <div className="container mx-auto px-4 py-8">
        <div className="mx-auto max-w-2xl text-center">
          <h1 className="mb-4 text-8xl font-bold text-gray-300">404</h1>
          <h2 className="mb-4 text-3xl font-semibold">页面未找到</h2>
          <p className="mb-8 text-gray-600">抱歉，您访问的页面不存在或已被移除。</p>

          <div className="space-y-4">
            <Link
              to="/"
              className="inline-block rounded-md bg-blue-500 px-6 py-3 text-white transition-colors hover:bg-blue-600"
            >
              返回首页
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
